/* eslint-disable no-undefined */
// ^ Intl.NumberFormat needs an explicit `undefined` in order to use the browser's current locale
import { __assign } from "tslib";
/**
 * Clamps a number within a specified range boundary (inclusive at both ends)
 * @param {Number} value The number to clamp
 * @param {Number} min The minimum value to allow
 * @param {Number} max The maximum value to allow
 */
var clamp = function (value, min, max) {
    return Math.min(Math.max(value, min), max);
};
/**
 * Gets the formatter for a specific currency code
 * @param {String} currency The ISO 4217 currency code ("USD", "EUR", etc)
 */
var getCurrencyFormatter = function (currency, options) {
    if (currency) {
        return new Intl.NumberFormat(undefined, __assign(__assign({ minimumFractionDigits: 0, style: 'currency' }, options), { currency: currency }));
    }
    return new Intl.NumberFormat(undefined, { minimumFractionDigits: 0 });
};
/**
 * Formats a currency value.
 * @param {Number} value The value to format
 * @param {String} currency The ISO 4217 currency code ("USD", "EUR", etc) to use
 * @param {*} noValueResult The value to return if the provided `value` is not a number.
 */
var formatCurrency = function (value, currency, options, noValueResult) {
    var formatter = getCurrencyFormatter(currency, options);
    return typeof value === 'number' ? formatter.format(value) : noValueResult;
};
export { clamp, formatCurrency };
//# sourceMappingURL=numberUtils.js.map